import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { EventsHubService, EDITORMESSAGETYPE, EditorMessage } from "src/app/services/eventshub.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { Exam } from "src/app/models/exam";
import { Page } from "src/app/models/page";

@Component({
  selector: "hkt-editorpageslist",
  templateUrl: "./editorpageslist.component.html",
  styleUrls: ["./editorpageslist.component.scss"],
})
export class EditorPagesListComponent implements OnInit, OnDestroy {
  exam: Exam;
  examSubscription: Subscription;
  eventsHubSubscription: Subscription;
  currentPage: Page;

  constructor(
    private examService: ExamService,
    private eventsHubService: EventsHubService,
    private modalDialogService: ModalDialogService,
  ) {}

  ngOnInit() {
    this.exam = this.examService.currentExam;
    this.currentPage = this.exam.pages[this.exam.currentPageIndex];

    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => {
      this.exam = exam;
      this.currentPage = this.exam.pages[this.exam.currentPageIndex];
    });

    this.eventsHubSubscription = this.eventsHubService.onEditorMessage.subscribe(msg => {
      if (msg.type == EDITORMESSAGETYPE.SelectPage) {
        this.currentPage = msg.data;
      }
    });
  }

  ngOnDestroy() {
    this.examSubscription.unsubscribe();
    this.eventsHubSubscription.unsubscribe();
  }

  private sendMessageCurrentPageChanged() {
    let msg = new EditorMessage();
    msg.type = EDITORMESSAGETYPE.SelectPage;
    msg.data = this.exam.pages[this.exam.currentPageIndex];
    this.eventsHubService.setEditorMessage(msg);
  }

  onSelectPage(page: Page): void {
    let index = this.exam.pages.indexOf(page);
    if (index >= 0) {
      this.exam.currentPageIndex = index;
      this.sendMessageCurrentPageChanged();
    }
  }

  onMovePageLeft(page: Page): void {
    let index = this.exam.pages.indexOf(page);
    if (index >= 0) {
      let tmp = this.exam.pages[index];
      this.exam.pages[index] = this.exam.pages[index - 1];
      this.exam.pages[index - 1] = tmp;

      if (this.exam.currentPageIndex == index) {
        this.exam.currentPageIndex--;
        this.sendMessageCurrentPageChanged();
      } else if (this.exam.currentPageIndex == index - 1) {
        this.exam.currentPageIndex++;
        this.sendMessageCurrentPageChanged();
      }
    }
  }
  onMovePageRight(page: Page): void {
    let index = this.exam.pages.indexOf(page);
    if (index >= 0) {
      let tmp = this.exam.pages[index];
      this.exam.pages[index] = this.exam.pages[index + 1];
      this.exam.pages[index + 1] = tmp;

      if (this.exam.currentPageIndex == index) {
        this.exam.currentPageIndex++;
        this.sendMessageCurrentPageChanged();
      } else if (this.exam.currentPageIndex == index + 1) {
        this.exam.currentPageIndex--;
        this.sendMessageCurrentPageChanged();
      }
    }
  }

  onDuplicatePage(page: Page): void {
    let index = this.exam.pages.indexOf(page);
    if (index >= 0) {
      this.exam.duplicatePage(index);
    }
  }

  onDeletePage(page: Page): void {
    let index = this.exam.pages.indexOf(page);
    if (index >= 0) {
      this.modalDialogService.showConfirmation(Config.APP_NAME, "Are you sure to delete the page?", () => {
        // Yes
        this.exam.pages.splice(index, 1);
        if (this.exam.currentPageIndex == index) {
          if (this.exam.currentPageIndex != 0) {
            this.exam.currentPageIndex--;
          }
          this.sendMessageCurrentPageChanged();
        }
      });
    }
  }

  onAddPage(): void {
    this.exam.addPage();
    this.exam.currentPageIndex = this.exam.pages.length - 1;
    this.sendMessageCurrentPageChanged();
  }
}
